
export const environment = {
  production: false,
  appDeployUrl: 'https://chat.qwhery.cloud/qwchat',
  api: "http://chatapi.qwhery.cloud/",
}
